// extracted by mini-css-extract-plugin
export default {"referral-widget":"Fo","referral-page":"Go","label":"Ho","subHed":"Io","profile-container":"Jo","referral-container":"Ko","referral-header":"Lo","shareMethodRow":"Mo","shareMethod":"No","active":"Oo","referral-stat":"Po","blockwrapper":"Qo","referralLink":"Ro","bold":"So","semibold":"To","shareAgainButton":"Uo","policy":"Vo","narrowWrapper":"Wo"};
    if(module.hot) {
      // 1715632474753
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  